'use strict';

cartSeller.$inject = ["CartSellerProduct", "Totals", "CartErrorMessage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartSeller = cartSeller;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartSeller(CartSellerProduct, Totals, CartErrorMessage) {
    var clazz = function CartSeller() {
        var defaults = {
            id: 0,
            name: '',
            sellerCodeName: '',
            displayName: '',
            products: [],
            minOrderPriceExclVat: '',
            totals: null,
            errorMessages: null,
            sellerCodeId: 0,
            isVipSeller: false,
            protocolName: '',
            deliveryPartnerName: '',
            promoMessages: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedCart, product) {
            var sellerInUpdatedCart = _lodash2.default.find(updatedCart.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id && p.discountId === product.discountId;
                });
            });
            if (!sellerInUpdatedCart) {
                return;
            }

            this.totals.updateAfterSetQuantity(sellerInUpdatedCart.totals);
            this.errorMessages = sellerInUpdatedCart.errorMessages;
        },
        updateAfterRemove: function updateAfterRemove(sellerInUpdatedCart, product) {
            _lodash2.default.remove(this.products, function (p) {
                return p.id === product.id && p.discountId === product.discountId;
            });
            this.totals.updateAfterSetQuantity(sellerInUpdatedCart.totals);
            this.errorMessages = sellerInUpdatedCart.errorMessages;
        }
    });

    clazz.create = function (resource, products) {
        var o = new clazz();
        o.id = resource.sellerId;
        o.sellerCodeId = resource.sellerCodeId;
        o.name = resource.name;
        o.sellerCodeName = resource.sellerCodeName;
        o.isVipSeller = resource.isVipSeller;
        o.protocolName = resource.protocolName;
        o.deliveryPartnerName = resource.deliveryPartnerName;
        o.prefix = resource.prefix;
        o.canOrderSpecial = resource.canOrderSpecial;

        if (products) {
            o.products = products.filter(function (product) {
                o.minOrderPriceExclVat = resource.minOrderPriceExclVat;
                return product.sellerId === resource.sellerCodeId;
            });
            o.products = _lodash2.default.map(o.products, function (i) {
                return CartSellerProduct.create(i);
            });
        }

        o.totals = Totals.create(resource);
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.create(i);
        });
        o.displayName = resource.displayName;
        o.promoMessages = resource.promoMessages;

        // if (resource.name !== resource.sellerCodeName) {
        //     resource.onlyOneSellerCode ? o.name : o.displayName += ' - ' + resource.sellerCodeName;
        // }
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.sellerCodeId = resource.sellerCodeId;
        o.name = resource.name;
        o.sellerCodeName = resource.sellerCodeName;
        o.displayName = resource.displayName;
        o.products = _lodash2.default.map(resource.products, function (i) {
            return CartSellerProduct.createFromLocalStorage(i);
        });
        o.totals = Totals.createFromLocalStorage(resource);
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.createFromLocalStorage(i);
        });
        o.isVipSeller = resource.isVipSeller;
        o.protocolName = resource.protocolName;
        o.deliveryPartnerName = resource.deliveryPartnerName;
        o.minOrderPriceExclVat = resource.minOrderPriceExclVat;
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/cartSellerModel.js
// module id = 735
// module chunks = 0